// API base URL
const API_BASE_URL = '/api';

/**
 * Validate a coupon code
 * @param {string} couponCode - Coupon code to validate
 * @param {number} baseAmount - Base amount in paise
 * @returns {Promise} Validation result
 */
export const validateCoupon = async (couponCode, baseAmount) => {
    try {
        const response = await fetch(`${API_BASE_URL}/coupon/validate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ couponCode, baseAmount })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to validate coupon');
        }

        return data;
    } catch (error) {
        console.error('Validate coupon error:', error);
        throw error;
    }
};
